export default "__VITE_ASSET__bcd623d0__"